import styled from "styled-components";
import { Theme } from "../../Common/Theme";

/* Same visual language as the DD TierSelector, so plans and one-off tiers read as one choice. */

export const PlanGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  width: 100%;

  /* Two by two, so no plan is ever left alone in a row */
  @media (max-width: ${Theme.breakpoints.md}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const PlanOption = styled.button<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 2px solid ${(p) => (p.$selected ? "#67D9D4" : "#e5e7eb")};
  background-color: ${(p) => (p.$selected ? "#F0FFFE" : "#fafafa")};
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s, background-color 0.15s;

  &:hover:not(:disabled) {
    border-color: ${(p) => (p.$selected ? "#67D9D4" : "#9CA3AF")};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

/* Sizes and colours below are the TierSelector ones: subtitle, title, price. */

export const PlanName = styled.span`
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #9ca3af;
`;

export const PlanAudience = styled.span`
  font-size: 0.7rem;
  color: #9ca3af;
  line-height: 1.35;
  min-height: 2.7em;
`;

export const PlanPrice = styled.span<{ $selected: boolean }>`
  margin-top: 4px;
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1.3;
  color: ${(p) => (p.$selected ? "#0D9488" : "#111827")};

  small {
    margin-left: 2px;
    font-weight: 600;
    color: #6b7280;
  }
`;

export const PlanCredits = styled.span<{ $selected: boolean }>`
  margin-top: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  color: ${(p) => (p.$selected ? "#0D9488" : "#6b7280")};
`;

export const PlanCreditsNote = styled.span`
  font-size: 0.7rem;
  color: #9ca3af;
`;

export const PlanUnavailable = styled.span`
  margin-top: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #6b7280;
`;

export const PlanExample = styled.div`
  width: 100%;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 1px;
  font-size: 0.7rem;
  color: #374151;
`;

export const PlanExampleLabel = styled.span`
  font-size: 0.65rem;
  color: #9ca3af;
`;

export const PlanOneOffPrice = styled.span`
  color: #6b7280;
`;

export const PlanSavings = styled.span`
  font-weight: 700;
  color: #0D9488;
`;

export const PlanNotes = styled.p`
  margin: 10px 0 0;
  font-size: 0.75rem;
  color: #6b7280;
`;
